// extracted by mini-css-extract-plugin
export default {"button":"Close_button__0j1HT"};